export default "__VITE_ASSET__BtYQKEWr__"